/**
 * Smart API URL utility
 * Uses relative URLs on production to avoid CORS/auth issues
 * Uses configured URL on preview environments
 * 
 * NOTE: This must work at RUNTIME, not just build time, because
 * Create React App bakes env vars into the bundle at build time
 */

export function getApiUrl() {
  // If we're in a browser, determine the correct URL based on current domain
  if (typeof window !== 'undefined') {
    const currentOrigin = window.location.origin;
    const currentHost = window.location.hostname;
    
    // On production domains, ALWAYS use relative URLs
    if (currentHost === 'linedancecentral.uk' || currentHost === 'www.linedancecentral.uk') {
      return '';
    }
    
    // On any emergent.host production (non-preview) domain, use relative URLs
    if (currentHost.includes('emergent.host') && !currentHost.includes('preview')) {
      return '';
    }
    
    // On preview environment, we can use relative URLs too (same origin)
    // This makes it simpler and more consistent
    if (currentHost.includes('preview.emergentagent.com')) {
      return '';
    }
    
    // For localhost development
    if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
      // Use the env var if set, otherwise relative
      const envUrl = process.env.REACT_APP_BACKEND_URL;
      if (envUrl && !envUrl.includes('preview.emergentagent.com')) {
        return envUrl;
      }
      return '';
    }
  }
  
  // Default: use relative URLs (safest option)
  return '';
}

// Export as constant - but note this is evaluated once at import time
// For dynamic needs, call getApiUrl() directly
export const API_URL = getApiUrl();
